import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '../bdo/services/storage.service';
import { RouteTrackingService } from '../bdo/services/route-tracking.service';
import { inject } from '@angular/core';
import { WizardComponent } from '../bdo/components/delivery/wizard/wizard.component';
import { ConfirmationService } from '../bdo/services/confirmation.service';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

export const cleanupWizardDataGuard: CanDeactivateFn<WizardComponent> = (
  component: WizardComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot
): Observable<boolean> => {
  const routeTrackingService = inject(RouteTrackingService);
  const confirmationService = inject(ConfirmationService);
  const translationService = inject(TranslateService);

  // no wizard for these routes
  const skipConfirmationAndCleanupPages = [
    'danke',
    'anpassen/tarifauswahl', // link possible from kuendigen, should not cleanup data
    'ablehnung', // SCHUFA
    'hinweis',
    'login',
    'vertrag/auth'
  ];
  if (skipConfirmationAndCleanupPages.some(page => nextState.url.includes(page))) {
    return of(true);
  }

  return confirmationService.showConfirmationPopup({
    title: translationService.instant('wizard.confirmation.title'),
    cancelButtonText: translationService.instant('wizard.confirmation.cancelButtonText'),
    confirmButtonText: translationService.instant('wizard.confirmation.confirmButtonText'),
    body: translationService.instant('wizard.confirmation.body'),
  }).pipe(tap((confirmLeave) => {
    if (confirmLeave) {
      StorageService.clearWizardData();
      routeTrackingService.clearWizardDataRun.set(true);
      return true;
    } else {
      return false;
    }
  }));
};
